import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['input', 'preview', 'button'] 

  connect() {
    // Prevent file to be opened on browser
    this.buttonTarget.addEventListener('dragover', (event) => {
      event.preventDefault();
    });

    this.buttonTarget.addEventListener('drop', (event) => {
      this.dropFile(event);

      // Prevent file to be opened on browser
      event.preventDefault();
    });
  } ;

  chooseFile(event) {
    event.preventDefault();

    this.inputTarget.click();
  };

  fileChosen(event) {
    this.previewTarget.innerHTML = event.target.files[0].name;
  };

  dropFile(event) {
    const file = event.dataTransfer.files[0];

    if (!file) return;

    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(file);

    this.inputTarget.files = dataTransfer.files;
    this.previewTarget.innerHTML = file.name;
  };
};
